import { Boundaries } from "@planzone/core";
import { Identifiable, Project } from "@planzone/dto";
import { removeLinkFromAttr } from "./utils";

function handleRemoveProjectExternalLinkRequest(
  project: Identifiable<Project>,
  req: Boundaries["removeProjectExternalLink"]["request"],
): Identifiable<Project> {
  return req.project.uuid === project.uuid
    ? {
        ...project,
        attributes: removeLinkFromAttr(project.attributes, req.link),
      }
    : project;
}

function handleRemoveProjectExternalLinkSuccess(
  project: Identifiable<Project>,
  req: Boundaries["removeProjectExternalLink"]["success"],
): Identifiable<Project> {
  return req.project.uuid === project.uuid
    ? {
        ...project,
        attributes: removeLinkFromAttr(project.attributes, req.link),
      }
    : project;
}

function handleRemoveProjectExternalLinkFailure(
  project: Identifiable<Project>,
  req: Boundaries["removeProjectExternalLink"]["failure"],
): Identifiable<Project> {
  return req.project.uuid === project.uuid
    ? {
        ...project,
        attributes: {
          ...req.project.attributes,
          [`link.${req.link.name}.url`]: req.link.url,
          [`link.${req.link.name}.name`]: req.link.name,
        },
      }
    : project;
}

export {
  handleRemoveProjectExternalLinkRequest,
  handleRemoveProjectExternalLinkSuccess,
  handleRemoveProjectExternalLinkFailure,
};
